import { render, staticRenderFns } from "./PDPProductFamiliesItem.vue?vue&type=template&id=0820f481&scoped=true"
import script from "./PDPProductFamiliesItem.vue?vue&type=script&lang=js"
export * from "./PDPProductFamiliesItem.vue?vue&type=script&lang=js"
import style0 from "./PDPProductFamiliesItem.vue?vue&type=style&index=0&id=0820f481&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0820f481",
  null
  
)

export default component.exports